import { render, staticRenderFns } from "./UBO-Profile.vue?vue&type=template&id=7fee8ef6&"
import script from "./UBO-Profile.vue?vue&type=script&lang=js&"
export * from "./UBO-Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports